import { type Dispatch, type SetStateAction } from 'react';
import { type LayoutNodeStyle } from 'shop-ui/types';

type ID = string;

type StyleMap = LayoutNodeStyle;

type StyleMapUpdateAction = (newStyleMap: StyleMap) => void;

type ContentMap = string;

type ContentMapUpdateAction = Dispatch<SetStateAction<ContentMap>>;

class UIStyleUpdater {
    _styleMapUpdateActions: Map<ID, StyleMapUpdateAction>;

    _contentMapUpdateActions: Map<ID, ContentMapUpdateAction>;

    constructor() {
        this._styleMapUpdateActions = new Map();

        this._contentMapUpdateActions = new Map();
    }

    subscribeStyleMapUpdate(id: ID, action: StyleMapUpdateAction) {
        this._styleMapUpdateActions.set(id, action);
    }

    subscribeContentMapUpdate(id: ID, action: ContentMapUpdateAction) {
        this._contentMapUpdateActions.set(id, action);
    }

    updateStyle(id: ID, styleMap: StyleMap) {
        this._styleMapUpdateActions.get(id)?.(styleMap);
    }

    updateContent(id: ID, contentMap: ContentMap) {
        this._contentMapUpdateActions.get(id)?.(contentMap);
    }

    unsubscribeStyleMapUpdate(id: ID) {
        this._styleMapUpdateActions.delete(id);
    }

    unsubscribeContentMapUpdate(id: ID) {
        this._contentMapUpdateActions.delete(id);
    }
}

const instance = new UIStyleUpdater();

export { instance as uiStyleUpdater };
